// extracted by mini-css-extract-plugin
module.exports = {"desktopNav":"DesktopNav-module--desktop-nav--YfWEZ","isActive":"DesktopNav-module--is-active--3voCp"};